import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
    return (
        <div className="min-h-screen bg-ink grain pt-24 pb-16 px-6 md:px-10" data-testid="privacy-page">
            <div className="max-w-3xl mx-auto">
                <Link to="/" className="inline-flex items-center gap-2 text-gold hover:text-gold-light text-xs tracking-widest uppercase mb-6">
                    <ArrowLeft size={14} /> Torna alla home
                </Link>
                <div className="text-gold text-xs tracking-[0.4em] uppercase">Documento legale</div>
                <h1 className="font-serif text-4xl md:text-5xl text-white mt-2 mb-2">Informativa sulla privacy</h1>
                <p className="text-gray-500 text-xs">Ultimo aggiornamento: 24 aprile 2026 · Ai sensi del Reg. UE 2016/679 (GDPR)</p>

                <article className="prose prose-invert prose-sm max-w-none mt-10 text-gray-300 leading-relaxed space-y-6">
                    <Section title="1. Titolare del trattamento">
                        <p><strong className="text-white">MAKAI di Maria Laura Pellino</strong></p>
                        <p>Partita IVA: <span className="text-gold">09936410969</span></p>
                        <p>Sito: <Link className="text-gold" to="/">renova360-reservation.it</Link></p>
                        <p>Email del titolare: <span className="text-gold">privacy@renova360-reservation.it</span></p>
                    </Section>

                    <Section title="2. Tipologie di dati raccolti">
                        <ul className="list-disc pl-5 space-y-1.5">
                            <li><strong className="text-white">Dati clienti</strong>: nome, email, telefono, dati di prenotazione (data, ora, coperti, allergie), preferenze (animale al seguito).</li>
                            <li><strong className="text-white">Dati ristoratori</strong>: ragione sociale, indirizzo, P.IVA, telefono, email del titolare.</li>
                            <li><strong className="text-white">Dati di pagamento</strong>: gestiti integralmente da Stripe (PCI-DSS Level 1). Non conserviamo numeri di carta.</li>
                            <li><strong className="text-white">Dati di navigazione</strong>: IP, user agent, log tecnici (conservazione 30 giorni).</li>
                        </ul>
                    </Section>

                    <Section title="3. Finalità e basi giuridiche">
                        <ul className="list-disc pl-5 space-y-1.5">
                            <li>Erogazione del servizio di prenotazione — base: esecuzione del contratto.</li>
                            <li>Fatturazione e adempimenti fiscali — base: obbligo di legge.</li>
                            <li>Comunicazioni di servizio (conferme, promemoria) — base: legittimo interesse / contratto.</li>
                            <li>Analytics anonimi — base: consenso (revocabile in ogni momento).</li>
                        </ul>
                    </Section>

                    <Section title="4. Conservazione dei dati">
                        I dati di prenotazione sono conservati per <strong className="text-white">10 anni</strong> per finalità contabili. I log tecnici sono cancellati dopo 30 giorni. Puoi richiedere la cancellazione anticipata scrivendo a <span className="text-gold">privacy@renova360-reservation.it</span> (salvo obblighi di legge contrari).
                    </Section>

                    <Section title="5. Comunicazione a terzi">
                        I dati possono essere comunicati a:
                        <ul className="list-disc pl-5 mt-2 space-y-1.5">
                            <li>Il ristorante presso cui è effettuata la prenotazione (limitatamente ai dati strettamente necessari).</li>
                            <li><strong className="text-white">Stripe</strong> (USA/Irlanda) — pagamenti, conforme SCC.</li>
                            <li><strong className="text-white">Resend</strong> (USA) — invio email transazionali.</li>
                            <li>Hosting cloud su infrastruttura europea / Cloudflare (CDN).</li>
                        </ul>
                    </Section>

                    <Section title="6. Diritti dell'interessato (artt. 15-22 GDPR)">
                        Hai diritto di: accesso, rettifica, cancellazione, limitazione, opposizione, portabilità. Per esercitarli scrivi a <span className="text-gold">privacy@renova360-reservation.it</span>. Hai inoltre il diritto di proporre reclamo al Garante (<a href="https://www.garanteprivacy.it" target="_blank" rel="noreferrer" className="text-gold underline">www.garanteprivacy.it</a>).
                    </Section>

                    <Section title="7. Sicurezza">
                        Adottiamo misure tecniche e organizzative adeguate (TLS 1.3, hashing bcrypt password, accessi limitati, MFA per il super admin). Le carte di credito non sono mai persistite sui nostri server.
                    </Section>

                    <Section title="8. Modifiche all'informativa">
                        Eventuali modifiche saranno pubblicate su questa pagina con la data di aggiornamento.
                    </Section>
                </article>
            </div>
        </div>
    );
}

function Section({ title, children }) {
    return (
        <section>
            <h2 className="text-gold font-serif text-xl mt-6 mb-3 font-light">{title}</h2>
            <div className="text-sm text-gray-300 leading-relaxed">{children}</div>
        </section>
    );
}
